<template>
  <div class="offset-md-3 col-md-6">
    <b-card bg-variant="dark" text-variant="white" title="Настройки сметы" class="my-2">

      <b-input-group prepend="Организация" class="mt-1">
        <b-form-select v-model="selectedOrg" :options="orgList">
        </b-form-select>
      </b-input-group>

      <b-row class="my-2">
        <b-col sm="3" class="text-right">
          <label class="my-1">Приложение №1</label>
        </b-col>
        <b-col sm="9">
          <b-form-input type="text" v-model="sett.appendText" placeholder="Приложение к приказу"/>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col sm="3" class="text-right">
          <label class="my-1">Утверждает ФИО</label>
        </b-col>
        <b-col sm="9">
          <b-form-input type="text" v-model="sett.affirmFio" placeholder="Утверждает Фамилия И.О."/>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col sm="3" class="text-right">
          <label class="my-1">Согласовано ФИО</label>
        </b-col>
        <b-col sm="9">
          <b-form-input type="text" v-model="sett.approveFio" placeholder="Согласовывает Фамилия И.О."/>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col sm="3" class="text-right">
          <label class="my-1">Главный бухгалтер ФИО</label>
        </b-col>
        <b-col sm="9">
          <b-form-input type="text" v-model="sett.chiefBuh" placeholder="Главный бухгалтер Фамилия И.О."/>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col sm="3" class="text-right">
          <label class="my-1">Начальник отдела ФИО</label>
        </b-col>
        <b-col sm="9">
          <b-form-input type="text" v-model="sett.headDepartment" placeholder="Главный бухгалтер Фамилия И.О."/>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col sm="3" class="text-right">
          <label class="my-1">Экономист ГБУ ЦБ ФИО</label>
        </b-col>
        <b-col sm="9">
          <b-form-input type="text" v-model="sett.generalEconomist" placeholder="Экономист ГБУ ЦБ Фамилия И.О."/>
        </b-col>
      </b-row>

      <hr>

      <b-row class="my-2">
        <b-col sm="3" class="text-right">
          <label class="my-1">Процент начисления</label>
        </b-col>
        <b-col sm="9">
          <b-form-input type="number" v-model="sett.percent"/>
        </b-col>
      </b-row>

      <div class="text-right">
        <b-button class="mt-1 mr-1" variant="primary" @click="saveSetting">Сохранить</b-button>
      </div>

      <transition>
        <b-alert class="my-2"
                 :show="dismissCountDown"
                 dismissible
                 variant="warning"
                 fade
                 @dismissed="dismissCountDown=0"
                 @dismiss-count-down="countDownChanged"
        >Настройки сохранены!!!
        </b-alert>
      </transition>

    </b-card>

  </div>
</template>

<script>
import http from '@/http-common'

export default {
  name: 'SettingSmeta',
  data() {
    return {
      sett: {
        id: 0,
        affirmFio: '',
        approveFio: '',
        chiefBuh: '',
        headDepartment: '',
        generalEconomist: '',
        percent: 0,
        orgId: 0
      },
      dismissSecs: 3,
      dismissCountDown: 0,
      selectedOrg: 0,
      orgList: []
    }
  },
  created() {
    this.loadOrgs();
    //this.loadSett();
  },
  watch: {
    selectedOrg: function (val) {
      this.loadSett()
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    loadSett() {
      var vm = this;
      http.get('/setting/smeta?orgId=' + this.selectedOrg)
      .then((response) => {
        if (response.data != null && response.data != "") {
          vm.sett = response.data;
        } else {
          vm.sett = {}
        }
      })
      .catch((error) => console.log(error.response.data));
    },
    saveSetting() {
      this.sett.orgId = this.selectedOrg;
      http.post('/setting/smeta', this.sett)
      .then((response) => {
        var dataR = response.data;
        if (dataR.id == 0) {
          alert("Ошибка сохранения!!!")
        } else {
          this.showAlert();
        }
      })
      .catch((error) => {
        if (error.response.status == 403) {
          alert("Нет прав!")
        } else {
          alert("Ошибка сохранения на сервере!!!")
        }
      });
    },
    loadOrgs() {
      var vm = this;
      http.get('/org/list')
      .then((response) => {
        vm.orgList = response.data;
        vm.orgList.forEach(function (x) {
          x.value = x.id;
          x.text = x.shortName;
        })
        vm.selectedOrg = vm.orgList[0].id;
      })
      .catch((error) => console.log(error.message));
    },
    test() {
      alert(this.selectedOrg)
    }
  }
}
</script>
